/** @jsx jsx */
import { jsx, Box, Flex, Text, Link } from "theme-ui";

import Div100 from "react-div-100vh";
import Layout from "components/layouts/default";
import OnScreen from "components/on-screen";

function HowItWorks() {
  return (
    <Flex as={Div100} variant="boxes.column">
      <Layout>
        <Box
          m="auto"
          px={["m", null, "l"]}
          sx={{ maxWidth: 320, textAlign: "center" }}
        >
          <OnScreen parent>
            {/* buy */}
            <OnScreen child>
              <Box mb="xl">
                <Text variant="stnd.xs" mb="s">
                  Buy
                </Text>
                <Text>
                  Buy a token at the current market price. The price is dynamic,
                  based on the demand for the product. Purchases are carried out
                  via{" "}
                  <Link
                    href="https://makerdao.com/en/"
                    target="_blank"
                    variant="default"
                  >
                    Dai
                  </Link>
                  {` `}~ a crypto version of the US dollar.
                </Text>
              </Box>
            </OnScreen>
            {/* redeem */}
            <OnScreen child>
              <Box mb="xl">
                <Text variant="stnd.xs" mb="s">
                  Redeem
                </Text>
                <Text>
                  When redemptions open, you will be able to trade in your token
                  for the real, physical good.
                </Text>
              </Box>
            </OnScreen>
            {/* sell */}
            <OnScreen child>
              <Text variant="stnd.xs" mb="s">
                Sell
              </Text>
              <Text>
                If the price has changed and you’d rather cash out — you can
                sell your token back into the market.
              </Text>
            </OnScreen>
          </OnScreen>
        </Box>
      </Layout>
    </Flex>
  );
}

export default HowItWorks;
